import { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import {
  FaUsers,
  FaPlus,
  FaEdit,
  FaTrash,
  FaFileExcel,
  FaSearch,
  FaPhone
} from 'react-icons/fa';

function Parents() {

  const [parents, setParents] = useState([]);
  const [search, setSearch] = useState('');

  const [parentName, setParentName] = useState('');
  const [mobile, setMobile] = useState('');

  const [editId, setEditId] = useState(null);

  useEffect(() => {
    fetchParents();
  }, []);

  const fetchParents = () => {

    axios.get(
      `${process.env.REACT_APP_API_URL}/parents`
    )
    .then((res) => {
      setParents(res.data);
    })
    .catch((err) => {
      console.log(err);
    });

  };

  const exportToExcel = () => {

    const worksheet =
      XLSX.utils.json_to_sheet(parents);

    const workbook =
      XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      'Parents'
    );

    const excelBuffer = XLSX.write(
      workbook,
      {
        bookType: 'xlsx',
        type: 'array'
      }
    );

    const data = new Blob(
      [excelBuffer],
      {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    );

    saveAs(data, 'Parents.xlsx');

  };

  const addParent = () => {

    if (!parentName || !mobile) {

      alert('Please fill all fields');

      return;

    }

    axios.post(
      `${process.env.REACT_APP_API_URL}/parent`,
      {
        parent_name: parentName,
        mobile: mobile
      }
    )
    .then(() => {

      alert('Parent Added Successfully');

      setParentName('');
      setMobile('');

      fetchParents();

    })
    .catch((err) => {
      console.log(err);
    });

  };

  const editParent = (parent) => {

    setEditId(parent.id);
    setParentName(parent.parent_name);
    setMobile(parent.mobile);

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

  };

  const updateParent = () => {

    axios.put(
      `${process.env.REACT_APP_API_URL}/parents/${editId}`,
      {
        parent_name: parentName,
        mobile: mobile
      }
    )
    .then(() => {

      alert('Parent Updated Successfully');

      setEditId(null);
      setParentName('');
      setMobile('');

      fetchParents();

    })
    .catch((err) => {
      console.log(err);
    });

  };

  const deleteParent = (id) => {

    if (
      !window.confirm(
        'Delete this parent?'
      )
    ) {
      return;
    }

    axios.delete(
      `${process.env.REACT_APP_API_URL}/parents/${id}`
    )
    .then(() => {

      alert('Parent Deleted');

      fetchParents();

    })
    .catch((err) => {
      console.log(err);
    });

  };

  const cancelEdit = () => {

    setEditId(null);
    setParentName('');
    setMobile('');

  };

  return (

    <Layout>

      <div className="container-fluid">

        <div className="mb-4">

          <h1
            style={{
              fontWeight: '800',
              color: '#0f172a'
            }}
          >
            Parents Management
          </h1>

          <p
            style={{
              color: '#64748b'
            }}
          >
            Manage all parent records
          </p>

        </div>

        {/* FORM */}

        <div
          className="card p-4 mb-4"
          style={{
            borderRadius: '24px'
          }}
        >

          <h4 className="mb-4">

            {editId ? (
              <>
                <FaEdit /> Edit Parent
              </>
            ) : (
              <>
                <FaPlus /> Add Parent
              </>
            )}

          </h4>

          <div className="row">

            <div className="col-md-6 mb-3">

              <input
                className="form-control"
                placeholder="Parent Name"
                value={parentName}
                onChange={(e) =>
                  setParentName(
                    e.target.value
                  )
                }
              />

            </div>

            <div className="col-md-6 mb-3">

              <input
                className="form-control"
                placeholder="Mobile Number"
                value={mobile}
                onChange={(e) =>
                  setMobile(
                    e.target.value
                  )
                }
              />

            </div>

          </div>

          {editId ? (

            <>
              <button
                className="btn btn-success"
                onClick={updateParent}
              >
                Update Parent
              </button>

              <button
                className="btn btn-secondary mt-2"
                onClick={cancelEdit}
              >
                Cancel
              </button>
            </>

          ) : (

            <button
              className="btn btn-primary"
              onClick={addParent}
            >
              Add Parent
            </button>

          )}

        </div>

        {/* TABLE */}

        <div
          className="card p-4"
          style={{
            borderRadius: '24px'
          }}
        >

          <div className="d-flex justify-content-between align-items-center mb-4">

            <h4>
              <FaUsers /> Parents List
            </h4>

            <button
              className="btn btn-success"
              onClick={exportToExcel}
            >
              <FaFileExcel /> Export Excel
            </button>

          </div>

          <div className="input-group mb-4">

            <span className="input-group-text">
              <FaSearch />
            </span>

            <input
              className="form-control"
              placeholder="Search Parent..."
              value={search}
              onChange={(e) =>
                setSearch(
                  e.target.value
                )
              }
            />

          </div>

          <div className="table-responsive">

            <table className="table">

              <thead>

                <tr
                  style={{
                    background:
                      '#eef2ff'
                  }}
                >

                  <th>ID</th>
                  <th>Parent Name</th>
                  <th>Mobile</th>
                  <th width="180">
                    Actions
                  </th>

                </tr>

              </thead>

              <tbody>

                {parents
                  .filter(
                    (parent) =>
                      parent.parent_name
                        .toLowerCase()
                        .includes(
                          search.toLowerCase()
                        ) ||
                      parent.mobile
                        .toString()
                        .includes(search)
                  )
                  .map((parent) => (

                    <tr key={parent.id}>

                      <td>
                        {parent.id}
                      </td>

                      <td>
                        {parent.parent_name}
                      </td>

                      <td>

                        <span
                          className="badge"
                          style={{
                            background:
                              '#dbeafe',
                            color:
                              '#1e40af',
                            padding:
                              '8px 12px'
                          }}
                        >
                          <FaPhone />{' '}
                          {parent.mobile}
                        </span>

                      </td>

                      <td>

                        <button
                          className="btn btn-warning btn-sm"
                          onClick={() =>
                            editParent(
                              parent
                            )
                          }
                        >
                          <FaEdit />
                        </button>

                        <button
                          className="btn btn-danger btn-sm ms-2"
                          onClick={() =>
                            deleteParent(
                              parent.id
                            )
                          }
                        >
                          <FaTrash />
                        </button>

                      </td>

                    </tr>

                  ))}

              </tbody>

            </table>

          </div>

        </div>

      </div>

    </Layout>

  );

}

export default Parents;